// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + "fcbafcb8" + ".chunk.js");